import { useCallback } from "react";
import { Coordinate } from "ol/coordinate";
import { PopoverBody } from "react-bootstrap";
import OverlayHeader from "./overlayHeader";
import { PopupOverlay } from "../../../../reactOL/overlays";
import { ViewResolutionChange } from "../../../../reactOL/interactions";

interface GbCensusOverlayProps {
  coordinate: Coordinate | undefined;
  closeOverlay: () => void;
  value: number | null;
  categoryTitle: string | undefined;
  message?: string;
}

const MIN_WIDTH = 200;
const MAX_WIDTH = 500;
const CH_PX = 8;
const MIN_ZOOM = 12;

const GbCensusOverlay = ({
  coordinate,
  closeOverlay,
  value,
  categoryTitle,
  message,
}: GbCensusOverlayProps) => {
  const width = `${Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, (categoryTitle?.length ?? 0) * CH_PX + 60))}px`;

  const handleZoomChange = useCallback(
    (zoom: number) => {
      if (zoom < MIN_ZOOM) closeOverlay();
    },
    [closeOverlay],
  );

  return (
    <>
      {coordinate !== undefined && (
        <ViewResolutionChange onResolutionChange={handleZoomChange} />
      )}
      <PopupOverlay width={width} coordinate={coordinate} placement="top">
        <PopoverBody className="text-center p-0" style={{ borderRadius: 7 }}>
          <OverlayHeader
            title={message ? "Attention" : (categoryTitle ?? "Column Value")}
            closeOverlay={closeOverlay}
          />
          <p>{message ?? value ?? 0}</p>
        </PopoverBody>
      </PopupOverlay>
    </>
  );
};

export default GbCensusOverlay;
